import { gql } from '@apollo/client';

export const APP_BUILDS = gql`
  query AppBuilds($filters: AppBuildFilters) {
    appBuilds(filters: $filters) {
      count
      data {
        id
        appName
        appType
        requestNumber
        environment
        assigneeId
        assigneeName
        androidAppVersion
        androidVersionCode
        androidStatus
        iosAppVersion
        iosBuildNumber
        iosStatus
        createdAt
      }
    }
  }
`;

export const APP_BUILD = gql`
  query AppBuild($appBuildId: ID!) {
    appBuild(id: $appBuildId) {
      id
      appName
      appType
      environment
      assigneeId
      assigneeName
      requesterName
      requesterEmail
      androidAppVersion
      androidVersionCode
      androidStatus
      apkTestLink
      aabSubmissionLink
      androidSubmissionMode
      androidRolloutMode
      iosAppVersion
      iosBuildNumber
      iosStatus
      ipaTestLink
      iosSubmissionMode
      iosRolloutMode
      googleDriveFolderLink
      whatsNewCopy
      releaseNotes
      reviewerCredentials
      projectId
    }
  }
`;

export const PROJECTS = gql`
  query projects($filters: ProjectsFilterInput) {
    projects(filters: $filters) {
      projects {
        id
        name
      }
    }
  }
`;

export const PROJECT = gql`
  query project($id: ID!) {
    project(id: $id) {
      id
      name
      gchatWebhookUrl
    }
  }
`;

export const APP_BUILD_ASSIGNEES = gql`
  query AppBuildAssignees {
    appBuildAssignees {
      id
      firstName
      lastName
      displayName
    }
  }
`;
